<template>
  <div class="header-common">
    <div class="header-common-wrapper">
      <nav class="header-common-logo">
			  <slot name="logo"><img :src="require('./assets/logo.png')" alt=""></slot>
      </nav>
      <div class="header-common-opt">
        <slot name="opt">
            <v-button type="link" kind="primary" @click="login">登录</v-button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    login() {
      window.location.href = '/ac/login';
    },
  },
};
</script>
<style lang="less" scoped>
.header-common {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #fff;
  img {
    width: 105px;
    height: 24px;
    margin: 16px 0 0 16px;
  }
  &-wrapper {
    display: flex;
    height: 100%;
    justify-content: space-between;
  }

  &-opt {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }
}
</style>